const invoiceFields = [
  "invoiceNumber", "invoiceDate", "invoiceTypeId", "typeId", "billingPeriodStart", "billingPeriodEnd",
  "currencyCode", "standardTaxRate", "reducedTaxRate", "taxExemptionReasonCode",
  "sellerName", "sellerPostcode", "sellerCity", "sellerStreet", "sellerCountryCode", "sellerGlobalID",
  "sellerGlobalIDSchemeIdentifier", "sellerElectronicAddress", "buyerName", "buyerPostcode", "buyerCity",
  "buyerStreet", "buyerCountryCode", "buyerGlobalID", "buyerGlobalIDSchemeIdentifier", "buyerElectronicAddress",
  "iban", "bic", "bankName", "paymentTerms", "buyerReference", "businessProcess",
];
const lineFields = ["name", "unitCode", "sellerAssignedID", "globalID", "grossUnitPrice", "netUnitPrice",
  "billedQuantity", "categoryCode", "taxPercent"];
const contactFields = ["contactType", "name", "orgUnit", "emailAddress", "phoneNo"];

function pick(source, fields) {
  return Object.fromEntries(fields.filter((key) => source[key] !== undefined).map((key) => [key, source[key]]));
}

function copyList(items, fields) {
  return Array.isArray(items) ? items.filter((item) => item && typeof item === "object").map((item) => pick(item, fields)) : [];
}

// The create DTO is the allowlist. IDs, files, OPOS allocations, totals and workflow
// state are deliberately absent, even if they were inserted through the JSON editor.
function invoiceDraftPayload(source) {
  if (!source?.invoice || typeof source.invoice !== "object") throw new TypeError("Invoice details are required.");
  const invoice = source.invoice;
  return {
    zugFeRDVersionId: source.zugFeRDVersionId || "230",
    zugFeRDProfileId: source.zugFeRDProfileId || "32",
    sourceFileId: null,
    invoice: {
      ...pick(invoice, invoiceFields),
      tradeLineItems: copyList(invoice.tradeLineItems, lineFields),
      sellerTaxRegistrations: copyList(invoice.sellerTaxRegistrations, ["taxRegNo", "taxSchemeID"]),
      buyerTaxRegistrations: copyList(invoice.buyerTaxRegistrations, ["taxRegNo", "taxSchemeID"]),
      notes: copyList(invoice.notes, ["content", "subjectCode"]),
      sellerContact: invoice.sellerContact ? pick(invoice.sellerContact, contactFields) : null,
      buyerContact: invoice.buyerContact ? pick(invoice.buyerContact, contactFields) : null,
    },
  };
}

function localDate() {
  const today = new Date();
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
}

function createInvoiceDraftCopy(source, invoiceDate = localDate()) {
  const draft = invoiceDraftPayload(source);
  draft.invoice.invoiceNumber = "";
  draft.invoice.invoiceDate = invoiceDate;
  draft.invoice.billingPeriodStart = null;
  draft.invoice.billingPeriodEnd = null;
  return draft;
}

function hasNewInvoiceNumber(number, sourceNumber) {
  return typeof number === "string" && number.trim().length > 0 && number.trim() !== String(sourceNumber || "").trim();
}

module.exports = { createInvoiceDraftCopy, invoiceDraftPayload, hasNewInvoiceNumber };
